/**
 * A band in the language of the interface (« 6,5 » in French, « 6.5 » in English): the rule is
 * `formatBand` of @agencyos/core, shared with the mobile app; this only supplies the web's language.
 */

import { formatBand } from "@agencyos/core";

import i18next from "../../lib/i18n";

export function bandText(value: number | null | undefined): string {
  return formatBand(value, i18next.language || "fr");
}
